export type ClaudeKeyKind = 'environment' | 'api-key' | 'unknown';

/** cse_… is a Claude self-hosted environment key; sk-ant-… is an Anthropic API key (the wrong kind). */
export function detectClaudeKeyKind(key: string): ClaudeKeyKind {
  const value = key.trim();
  if (value.startsWith('sk-ant')) return 'api-key';
  if (value.startsWith('cse_')) return 'environment';
  return 'unknown';
}

export type ClaudeKeyProblem = 'api-key' | 'format' | 'rejected';

export const CLAUDE_KEY_MESSAGES: Record<
  ClaudeKeyProblem | 'idle' | 'checking' | 'replace',
  string
> = {
  idle: 'Stored encrypted. Never written into Pod images.',
  checking: 'Checking the key with Claude. This takes a few seconds.',
  replace: 'The old key stops working when you save. Running Pods keep going.',
  'api-key':
    'That is an Anthropic API key. Paste the environment key instead; it starts with cse_live_.',
  format: 'Paste the environment key from your Claude organization; it starts with cse_live_.',
  rejected:
    'Claude did not accept this key. It may be revoked, or its environment was deleted. Create a new key and paste it here.',
};

/** The server's userError code as a key problem the form can show. */
export function claudeKeyProblem(errorCode: string): ClaudeKeyProblem {
  if (errorCode === 'KEY_IS_API_KEY') return 'api-key';
  if (errorCode === 'KEY_REJECTED') return 'rejected';
  return 'format';
}

const MASK = '••••••••••••••••';

export const maskEnvironmentKey = (hint: string | null): string => `cse_live_${MASK}${hint ?? ''}`;
export const maskSigningSecret = (hint: string | null): string => `whsec_${MASK}${hint ?? ''}`;
